import Carousel from './Carousel';

export { default as CarouselTheme } from './Carousel.style';
export default Carousel;
